var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Tresorerie") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Piles de disques et fleche de progression.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 256 169.8 L 450.3 282 L 256 394.2 L 61.7 282 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 196.2,
    x2: 107.4,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 293.2,
    y1: 217.6,
    x2: 144.5,
    y2: 303.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 330.3,
    y1: 239.1,
    x2: 181.7,
    y2: 324.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 367.5,
    y1: 260.6,
    x2: 218.8,
    y2: 346.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 404.6,
    y1: 282,
    x2: 256,
    y2: 367.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 256,
    y1: 196.2,
    x2: 404.6,
    y2: 282
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 218.8,
    y1: 217.6,
    x2: 367.5,
    y2: 303.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 181.7,
    y1: 239.1,
    x2: 330.3,
    y2: 324.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 144.5,
    y1: 260.6,
    x2: 293.2,
    y2: 346.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 107.4,
    y1: 282,
    x2: 256,
    y2: 367.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 154.5 262.2 L 154.5 272.1 A 32.9 19 0 0 0 220.3 272.1 L 220.3 262.2 A 32.9 19 0 0 1 154.5 262.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 154.5 262.2 L 154.5 272.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 220.3 262.2 L 220.3 272.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    fill: "none",
    d: "M 154.5 272.1 A 32.9 19 0 0 0 220.3 272.1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 187.4,
    cy: 262.2,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e2",
    fill: "none",
    cx: 187.4,
    cy: 262.2,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 154.5 251 L 154.5 260.9 A 32.9 19 0 0 0 220.3 260.9 L 220.3 251 A 32.9 19 0 0 1 154.5 251 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 154.5 251 L 154.5 260.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 220.3 251 L 220.3 260.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    fill: "none",
    d: "M 154.5 260.9 A 32.9 19 0 0 0 220.3 260.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 187.4,
    cy: 251,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e2",
    fill: "none",
    cx: 187.4,
    cy: 251,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 154.5 239.8 L 154.5 249.7 A 32.9 19 0 0 0 220.3 249.7 L 220.3 239.8 A 32.9 19 0 0 1 154.5 239.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 154.5 239.8 L 154.5 249.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 220.3 239.8 L 220.3 249.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    fill: "none",
    d: "M 154.5 249.7 A 32.9 19 0 0 0 220.3 249.7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 187.4,
    cy: 239.8,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e2",
    fill: "none",
    cx: 187.4,
    cy: 239.8,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 154.5 228.5 L 154.5 238.4 A 32.9 19 0 0 0 220.3 238.4 L 220.3 228.5 A 32.9 19 0 0 1 154.5 228.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 154.5 228.5 L 154.5 238.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 220.3 228.5 L 220.3 238.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    d: "M 154.5 238.4 A 32.9 19 0 0 0 220.3 238.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 187.4,
    cy: 228.5,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    fill: "none",
    cx: 187.4,
    cy: 228.5,
    rx: 32.9,
    ry: 19
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 276 283.7 L 276 293.6 A 28.6 16.5 0 0 0 333.2 293.6 L 333.2 283.7 A 28.6 16.5 0 0 1 276 283.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 276 283.7 L 276 293.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 333.2 283.7 L 333.2 293.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    fill: "none",
    d: "M 276 293.6 A 28.6 16.5 0 0 0 333.2 293.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 304.6,
    cy: 283.7,
    rx: 28.6,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e2",
    fill: "none",
    cx: 304.6,
    cy: 283.7,
    rx: 28.6,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 276 272.4 L 276 282.3 A 28.6 16.5 0 0 0 333.2 282.3 L 333.2 272.4 A 28.6 16.5 0 0 1 276 272.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 276 272.4 L 276 282.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 333.2 272.4 L 333.2 282.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    d: "M 276 282.3 A 28.6 16.5 0 0 0 333.2 282.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 304.6,
    cy: 272.4,
    rx: 28.6,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    fill: "none",
    cx: 304.6,
    cy: 272.4,
    rx: 28.6,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a flow",
    d: "M 187.4 216 L 244.6 199.5 L 304.6 247.4 L 370.3 192.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 357.5 193.7 L 370.3 192.9 L 357.5 212.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d3",
    cx: 244.6,
    cy: 199.5,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 244.6,
    cy: 199.5,
    r: 3.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 370.3,
    cy: 192.9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 370.3,
    cy: 192.9,
    r: 4.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.65277fdd5333fdd2928df77358f62919.svg";
export { ForwardRef as ReactComponent };